module.exports = __webpack_public_path__ + "img/icon-sign.00caefc8.png";